const getFileExtension = (fileName: string): string => {
  if (typeof fileName !== 'string') return '';

  const splitName = fileName.split('.');

  return splitName.length > 1 ? (splitName.pop()?.toLowerCase() as string) : '';
};

export default getFileExtension;
